import { INavConfig, getNavConfig } from '@/services/system-config-service';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AsyncThunkConfig } from '..';

const initialState: SystemConfigSliceDataType = {
  nav: {
    version: 0,
    navData: [],
  },
};

const systemConfigSlice = createSlice({
  name: 'systemConfig',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getNavConfigThunk.fulfilled, (state, action) => {
      state.nav.version = action.payload.version;
      state.nav.navData = action.payload.navData;
    });
  },
});

export default systemConfigSlice.reducer;
export interface SystemConfigSliceDataType {
  nav: {
    version: number;
    navData: INavConfig[];
  };
}

// Nav Config
export const getNavConfigThunk = createAsyncThunk<{ version: number; navData: INavConfig[] }, {}, AsyncThunkConfig>('systemConfig/getNavConfigThunk', async (_args, { getState }) => {
  const pageConfigData = getState().pageConfig;

  const response = await getNavConfig();
  const navData: INavConfig[] = [];
  if (response.data) {
    response.data[0].data.forEach((titleItem) => {
      titleItem.subMenu.forEach((collapseItem) => {
        collapseItem.subMenu.forEach((navItem) => {
          if (pageConfigData.allRoutePaths.includes(navItem.path) === false) return;

          const alreadyAddedNavTitle = navData.find((item) => item.key === titleItem.key);
          if (alreadyAddedNavTitle === undefined) navData.push({ ...titleItem, subMenu: [{ ...collapseItem, subMenu: [navItem] }] }); // navTitle doesnt exist
          else {
            // navTitle already exists
            const alreadyAddedNavCollapse = alreadyAddedNavTitle.subMenu.find((item) => item.key === collapseItem.key);
            if (alreadyAddedNavCollapse === undefined) alreadyAddedNavTitle.subMenu.push({ ...collapseItem, subMenu: [navItem] }); // navCollapse doesnt exist
            else alreadyAddedNavCollapse.subMenu.push(navItem); // navCollapse already exists
          }
        });
      });
    });
  }
  return response.data ? { version: response.data[0].__v, navData: navData } : { version: 0, navData: [] };
});
